/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import "./layout.css"
import FooterComponent from "./footer"
import MenuContext from "./menuContext"
import Menu from "./menu"

import "../themes/default/index.scss"

const Layout = ({ children }) => {
  const [open, setOpen] = useState(false)

  const contextValue = {
    open,
    openMenu: setOpen,
  }

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <MenuContext.Provider value={contextValue}>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <div
        className={
          contextValue.open
            ? ["menu-responsive active"]
            : ["menu-responsive desactive"]
        }
      >
        <Menu />
      </div>
      <main>{children}</main>
      <FooterComponent />
    </MenuContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
